import { Outlet } from 'react-router-dom'
import { Header } from '@/components/Header'
import { Navigation } from '@/components/Navigation'
import { ChatSlideout } from '@/components/Chat'
import { ActivityFeed } from '@/components/AgentActivity/ActivityFeed'
import { UndoBar } from '@/components/AgentActivity/UndoBar'
import { FocusDashboard } from '@/pages/FocusDashboard'
import { useUiStore } from '@/stores/uiStore'
import { cn } from '@/lib/utils'

export function MainLayout() {
  const { sidebarOpen, chatOpen, focusMode, activityPanelOpen } = useUiStore()

  // Focus Mode: sidebar hidden, 60/40 split with persistent chat
  if (focusMode) {
    return (
      <div className="min-h-screen bg-background">
        <Header />

        <div className="flex h-[calc(100vh-3.5rem)]">
          {/* Main content — 60% */}
          <main className="w-[60%] overflow-y-auto transition-all duration-300">
            <div className="p-4 md:p-6 max-w-3xl">
              <FocusDashboard />
            </div>
          </main>

          {/* Chat — persistent 40% right panel */}
          <div className="w-[40%] border-l border-border/30">
            <ChatSlideout className="!fixed !right-0 !w-[40%] !translate-x-0 !z-auto" />
          </div>
        </div>

        {/* Activity feed panel */}
        <ActivityFeed />

        {/* Undo bar */}
        <UndoBar />
      </div>
    )
  }

  // Normal layout
  return (
    <div className="min-h-screen bg-background">
      <Header />

      <div className="flex">
        {/* Sidebar */}
        <aside
          className={cn(
            'fixed left-0 top-14 z-40 h-[calc(100vh-3.5rem)] w-64 border-r border-sidebar-border sidebar-panel-bg shadow-[4px_0_16px_-4px_hsl(var(--primary)/0.05)] transition-transform duration-200 ease-in-out',
            'md:translate-x-0',
            sidebarOpen ? 'translate-x-0' : '-translate-x-full'
          )}
        >
          <Navigation />
        </aside>

        {/* Mobile overlay for sidebar */}
        {sidebarOpen && (
          <div
            className="fixed inset-0 z-30 bg-background/80 backdrop-blur-sm md:hidden"
            onClick={() => useUiStore.getState().setSidebarOpen(false)}
          />
        )}

        {/* Main content */}
        <main
          className={cn(
            'flex-1 md:ml-64 transition-all duration-300',
            chatOpen
              ? 'sm:mr-[440px] lg:mr-[480px]'
              : activityPanelOpen && 'lg:mr-80'
          )}
        >
          <div className="container mx-auto p-4 md:p-6 max-w-7xl">
            <Outlet />
          </div>
        </main>
      </div>

      {/* Chat slideout panel */}
      <ChatSlideout />

      {/* Activity feed panel */}
      <ActivityFeed />

      {/* Undo bar */}
      <UndoBar />
    </div>
  )
}
